export default "__VITE_ASSET__DYrq_aeI__"